import LegalPage from '../components/LegalPage';

const bullet = (items) => (
  <ul style={{ listStyleType: 'none', padding: 0 }} className="space-y-2">
    {items.map((item, i) => (
      <li key={i} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
        <span style={{ color: '#00F0FF', flexShrink: 0, marginTop: '6px' }}>&#9472;</span>
        <span>{typeof item === 'string' ? item : item}</span>
      </li>
    ))}
  </ul>
);

const sections = [
  {
    title: 'Acceptance of Terms',
    content: <p>By accessing and using the NeuroMesh platform ("Services"), you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these Terms, do not use our Services.</p>,
  },
  {
    title: 'Description of Services',
    content: (
      <div className="space-y-4">
        <p>NeuroMesh provides:</p>
        {bullet([
          'A decentralized intelligence layer for humanoid robots',
          'On-robot compute infrastructure (cCOMP)',
          'Data rights tokenization (nDATA-R)',
          'A protocol for verified robot intelligence',
          'Related documentation and developer tools',
        ])}
        <p style={{ color: '#666', fontSize: '13px', fontStyle: 'italic' }}>The Services are provided "as is" and "as available."</p>
      </div>
    ),
  },
  {
    title: 'Eligibility',
    content: <p>You must be at least 18 years old and have legal capacity to enter into contracts. By using Services, you represent that you meet these requirements.</p>,
  },
  {
    title: 'Account Responsibilities',
    content: (
      <div className="space-y-5">
        <div>
          <h3 style={{ color: '#ccc', fontSize: '13px', fontWeight: 600, marginBottom: '10px', fontFamily: "'JetBrains Mono', monospace", textTransform: 'uppercase', letterSpacing: '0.1em' }}>Wallet Connection</h3>
          {bullet([
            'You are responsible for maintaining custody of your Web3 wallet',
            'You are solely responsible for all activities under your wallet',
            'Immediately notify us of any unauthorized use',
          ])}
        </div>
        <div>
          <h3 style={{ color: '#ccc', fontSize: '13px', fontWeight: 600, marginBottom: '10px', fontFamily: "'JetBrains Mono', monospace", textTransform: 'uppercase', letterSpacing: '0.1em' }}>User Conduct — You agree NOT to:</h3>
          {bullet([
            'Use Services for any unlawful purpose',
            'Attempt to gain unauthorized access to any part of our systems',
            'Interfere with the proper operation of the protocol',
            'Submit false or misleading information',
            'Exploit vulnerabilities or conduct security testing without authorization',
          ])}
        </div>
      </div>
    ),
  },
  {
    title: 'Intellectual Property',
    content: (
      <div className="space-y-5">
        <div>
          <h3 style={{ color: '#ccc', fontSize: '13px', fontWeight: 600, marginBottom: '8px', fontFamily: "'Inter', sans-serif" }}>Our Rights</h3>
          <p>The NeuroMesh protocol, software, documentation, and all intellectual property are owned by Thalamus Labs Ltd or its licensors. You may not copy, modify, or distribute our intellectual property without authorization.</p>
        </div>
        <div>
          <h3 style={{ color: '#ccc', fontSize: '13px', fontWeight: 600, marginBottom: '8px', fontFamily: "'Inter', sans-serif" }}>Your Content</h3>
          <p>You retain ownership of content you submit to our Services. By submitting content, you grant us a license to use, host, and display it for providing Services.</p>
        </div>
        <div>
          <h3 style={{ color: '#ccc', fontSize: '13px', fontWeight: 600, marginBottom: '8px', fontFamily: "'Inter', sans-serif" }}>Token Rights</h3>
          <p>Token utilities (cCOMP, nDATA-R, nROBOT, $NEURO) are governed by their respective token specifications. Holding tokens does not grant ownership or equity in Thalamus Labs Ltd.</p>
        </div>
      </div>
    ),
  },
  {
    title: 'Disclaimers',
    content: (
      <div className="space-y-5">
        <div style={{ padding: '16px', background: 'rgba(255,215,0,0.04)', border: '1px solid rgba(255,215,0,0.12)', borderRadius: '6px' }}>
          <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '12px', color: '#FFD700', marginBottom: '8px', fontWeight: 600 }}>NO WARRANTIES</p>
          <p style={{ fontSize: '13px' }}>SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE." WE MAKE NO WARRANTIES, EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</p>
        </div>
        <p><strong style={{ color: '#ccc' }}>No Financial Advice:</strong> Nothing on our website constitutes financial, investment, or legal advice. Consult qualified professionals before making financial decisions.</p>
        <p><strong style={{ color: '#ccc' }}>Token Risk:</strong> Cryptocurrency and token investments are highly speculative. You may lose your entire investment. Past performance does not guarantee future results.</p>
        <p><strong style={{ color: '#ccc' }}>Smart Contract Risk:</strong> Our protocol relies on smart contracts deployed on public blockchains. These may contain vulnerabilities. Users bear all risk of smart contract interactions.</p>
      </div>
    ),
  },
  {
    title: 'Limitation of Liability',
    content: (
      <div style={{ padding: '16px', background: 'rgba(255,60,60,0.04)', border: '1px solid rgba(255,60,60,0.1)', borderRadius: '6px' }}>
        <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '12px', color: '#ff6b6b', marginBottom: '12px', fontWeight: 600 }}>TO THE MAXIMUM EXTENT PERMITTED BY LAW</p>
        {bullet([
          'NeuroMesh shall not be liable for any indirect, incidental, special, consequential, or punitive damages',
          'Our total liability shall not exceed the greater of $100 USD or the amounts paid to us in the 12 months preceding the claim',
          'We are not liable for loss of data, profits, or business opportunities',
          'We are not liable for robot malfunctions, physical harm, or property damage resulting from use of robots running NeuroMesh software',
        ])}
      </div>
    ),
  },
  {
    title: 'Indemnification',
    content: (
      <div className="space-y-3">
        <p>You agree to indemnify, defend, and hold harmless Thalamus Labs Ltd and its officers, directors, employees, and agents from any claims, damages, losses, or expenses (including attorney fees) arising from:</p>
        {bullet(['Your use of Services', 'Your violation of these Terms', 'Your submission of unlawful content', 'Your interaction with third parties through our Services'])}
      </div>
    ),
  },
  {
    title: 'Force Majeure',
    content: (
      <div className="space-y-3">
        <p>We are not liable for failure to perform obligations due to causes beyond our reasonable control, including:</p>
        {bullet(['Natural disasters', 'Government actions or restrictions', 'Blockchain network disruptions', 'Cyber attacks', 'Third-party service failures'])}
      </div>
    ),
  },
  {
    title: 'Termination',
    content: (
      <div className="space-y-4">
        <div>
          <h3 style={{ color: '#ccc', fontSize: '13px', fontWeight: 600, marginBottom: '8px', fontFamily: "'Inter', sans-serif" }}>Your Termination</h3>
          <p>You may stop using Services at any time. You may disconnect your wallet and request account deletion (subject to legal retention requirements).</p>
        </div>
        <div>
          <h3 style={{ color: '#ccc', fontSize: '13px', fontWeight: 600, marginBottom: '8px', fontFamily: "'Inter', sans-serif" }}>Our Termination</h3>
          <p>We may suspend or terminate your access to Services at our sole discretion, without notice, for violation of these Terms, suspected illegal activity, or protection of Services or users.</p>
        </div>
      </div>
    ),
  },
  {
    title: 'Dispute Resolution',
    content: (
      <div className="space-y-4">
        <p><strong style={{ color: '#ccc' }}>Governing Law:</strong> These Terms are governed by the laws of the British Virgin Islands (BVI).</p>
        <p><strong style={{ color: '#ccc' }}>Arbitration:</strong> Any disputes arising from these Terms shall be resolved through binding arbitration conducted in the British Virgin Islands.</p>
        <p><strong style={{ color: '#ccc' }}>Class Action Waiver:</strong> You agree to resolve disputes individually. No class or representative actions permitted.</p>
      </div>
    ),
  },
  {
    title: 'Contact',
    content: (
      <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '13px' }} className="space-y-1">
        <p style={{ color: '#fff' }}>Thalamus Labs Ltd</p>
        <p>Intershore Chambers, Road Town, Tortola, British Virgin Islands</p>
        <p style={{ marginTop: '12px' }}>Legal matters: <a href="mailto:legal@neuro-mesh.io" style={{ color: '#00F0FF' }}>legal@neuro-mesh.io</a></p>
      </div>
    ),
  },
];

export default function Terms() {
  return <LegalPage title="Terms of Service" lastUpdated="February 2026" sections={sections} />;
}
